import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AdminRouteGuard } from './core/admin-route.guard';

import { UnauthorizedComponent } from './home/unauthorized.component';
import { ErrorComponent } from './Error/Error.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AreaPageComponent } from './area-page/area-page.component';
import { CoverResolver } from './home/resolvers/cover.resolver';
import { CustomLayoutResolver } from './shared/resolvers/custom-layout.resolver';
import { AboutComponent } from './about/about.component';


const routes: Routes = [
  {
    path: '',
    pathMatch: "full",
    redirectTo: "home",
    resolve: {
      coverResolver: CoverResolver
    } 
  },
  { path: "Error", component: ErrorComponent },
  { path: "ChangePassword", component: ChangePasswordComponent },
  { path: "About", component: AboutComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: "home", component: HomeComponent, canActivate: [AdminRouteGuard], resolve: {
    coverResolver: CoverResolver,
    customLayoutResolver: CustomLayoutResolver
  } },
  { path: "AreaPage", component: AreaPageComponent, canActivate: [AdminRouteGuard]},
 
  { path: "login", component: LoginComponent },
  { path: 'AccountsReceivable', loadChildren: () => import('./accounts-receivable/accounts-receivable.module').then(m => m.AccountsReceivableModule),canActivate: [AdminRouteGuard] },
  { path: 'Administration', loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule),canActivate: [AdminRouteGuard] },
  { path: 'InventoryManagement', loadChildren: () => import('./inventory-management/inventory-management.module').then(m => m.InventoryManagementModule)},
  { path: 'SalesCommissions', loadChildren: () => import('./sales-commissions/sales-commissions.module').then(m => m.SalesCommissionsModule)},
  { path: 'Merchandising', loadChildren: () => import('./Merchandising/merchandising.module').then(m => m.MerchandisingModule),canActivate: [AdminRouteGuard]},
  { path: 'GeneralLedger', loadChildren: () => import('./general-ledger/general-ledger.module').then(g => g.GeneralLedgerModule), canActivate: [AdminRouteGuard] },
  { path: 'AccountsPayable', loadChildren: () => import('./accounts-payable/accounts-payable.module').then(m => m.AccountsPayableModule), canActivate: [AdminRouteGuard] },
  { path: 'FixedAssets', loadChildren: () => import('./fixed-assets/fixed-assets.module').then(m => m.FixedAssetsModule), canActivate: [AdminRouteGuard] },
  { path: 'SupervisorBeta', loadChildren: () => import('./supervisor/supervisor.module').then(m => m.SupervisorModule)},
  { path: 'ReportManager', loadChildren: () => import('./report-manager/report-manager.module').then(m => m.ReportManagerModule)},
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
